import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import './Produtos.css';
import MenuLateral from "../Components/MenuPrincipal/MenuLateral";
import ProdutoForm from "../Components/ProdutoForm/ProdutoForm";
import { useAuth } from "../Context/auth";

function NovoProduto() {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const [mensagem, setMensagem] = useState('');
    const [loading, setLoading] = useState(false);
    const [initialData, setInitialData] = useState({});
    const [codigoCarregado, setCodigoCarregado] = useState(false);

    useEffect(() => {
        if (!currentUser) return;
        const gerarProximoCodigo = async () => {
            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/produtos/next-code`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error('Falha ao gerar código.');
                const data = await response.json();
                setInitialData({ codigo: data.nextCode });
            } catch (error) {
                console.error("Erro ao gerar próximo código:", error);
                setInitialData({ codigo: '1' }); // Fallback
            } finally {
                setCodigoCarregado(true);
            }
        };
        gerarProximoCodigo();
    }, [currentUser]);

    async function handleCadastrar(formData) {
        if (!formData.codigo || !formData.descricao) {
            setMensagem('Código e Descrição são obrigatórios.');
            return;
        }
        setMensagem('');
        setLoading(true);
        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const response = await fetch(`${API_URL}/api/produtos`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify(formData)
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "Erro ao cadastrar produto.");
            }
            const responseData = await response.json();
            // Redireciona para a tela de edição do novo produto
            // CORREÇÃO: A rota correta é /app/editarproduto/:id
            navigate(`/app/editarproduto/${responseData.id}`, { replace: true });
            // A mensagem de sucesso seria idealmente passada via state ou exibida na nova tela, 
            // mas como vamos redirecionar, o EditarProduto pode carregar os dados.
        } catch (erro) {
            setMensagem(erro.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="produtos-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="produtos-header">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/produtos')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="produtos-title m-0">
                            Cadastrar <span className="highlight">Produto</span>
                        </h1>
                    </div>
                </div>

                <main className="produtos-content">
                    {mensagem && (
                        <div className="alert alert-danger d-flex align-items-center mb-4" role="alert">
                            <i className="fas fa-exclamation-circle me-2"></i>
                            <div>{mensagem}</div>
                        </div>
                    )}

                    {codigoCarregado ? (
                        <ProdutoForm
                            initialData={initialData}
                            onSubmit={handleCadastrar}
                            loading={loading}
                        />
                    ) : (
                        <div className="d-flex justify-content-center align-items-center w-100 flex-column" style={{ marginTop: '100px' }}>
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Carregando...</span>
                            </div>
                            <p className="mt-2 text-muted">Gerando código do produto...</p>
                        </div>
                    )}
                </main>
            </div>
        </div>
    );
}

export default NovoProduto;